// extracted by mini-css-extract-plugin
export default {"actionListOverrides":"RelationshipsSection-module__actionListOverrides--ysNvn","groupHeading":"RelationshipsSection-module__groupHeading--l5iUA"};